<h1 mat-dialog-title>
    <mat-icon class="{{data?.iconClass}}">{{data?.icon}}</mat-icon>
    {{data?.title}}
</h1>
<div mat-dialog-content>
    {{data?.message}}
</div>
<div mat-dialog-actions>
  @if (data?.buttonText && data?.buttonText != '') {
    <button mat-button class="tis-text-upper {{data?.buttonClass ?? 'tis-btn-primary'}}" (click)="onClose()" cdkFocusInitial>{{data?.buttonText}}</button>
  } @else {
    <button mat-button class="tis-text-upper {{data?.buttonClass ?? 'tis-btn-primary'}}" (click)="onClose()" cdkFocusInitial >OK</button>
  }
</div>
